import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { UpsellPage } from './pages/UpsellPage';
import { BetIQAccessPage } from './pages/BetIQAccessPage';
import { DownsellPage } from './pages/DownsellPage';
import { ThankYouPage } from './pages/ThankYouPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/upsell" element={<UpsellPage data-id="element-5" />} data-id="element-4" />
        <Route path="/betiq-access" element={<BetIQAccessPage data-id="element-7" />} data-id="element-6" />
        <Route path="/downsell" element={<DownsellPage data-id="element-9" />} data-id="element-8" />
        <Route path="/thank-you" element={<ThankYouPage data-id="element-11" />} data-id="element-10" />
      </Routes>
    </BrowserRouter>;
}